'use client';

import { c as _c } from "react/compiler-runtime";
import { useSearchParams, useRouter, type ReadonlyURLSearchParams } from 'next/navigation';
import { useSession } from '@/api/auth/client';
import { Suspense, useEffect } from 'react';
import { AUTH_PATHS, EXTENSION_PATH_PREFIX, EXTENSION_SOURCE_PARAM, EXTENSION_SOURCE_VALUE } from '@repo/api/auth/constants';
export default function AutoRedirect() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Suspense fallback={null}><AutoRedirectInternal /></Suspense>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
function AutoRedirectInternal() {
  const $ = _c(6);
  const searchParams = useSearchParams();
  const {
    data: session
  } = useSession();
  const router = useRouter();
  let t0;
  let t1;
  if ($[0] !== router || $[1] !== searchParams || $[2] !== session) {
    t0 = () => {
      if (!session) {
        return;
      }
      const target = resolveCallbackUrl(searchParams);
      console.log(`Already signed in. Redirecting to '${target}'`, session);
      router.push(target);
    };
    t1 = [router, searchParams, session];
    $[0] = router;
    $[1] = searchParams;
    $[2] = session;
    $[3] = t0;
    $[4] = t1;
  } else {
    t0 = $[3];
    t1 = $[4];
  }
  useEffect(t0, t1);
  let t2;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <></>;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}

/**
 * Resolves a safe post-auth redirect target.
 * - Extension flow (signalled by `source=extension` or an extension callbackUrl):
 *   the user must land on an extension path. If callbackUrl is missing or points
 *   outside the extension, fall back to EXTENSION_HOME. Never send them to a
 *   dashboard page.
 * - Dashboard flow: honor callbackUrl, fall back to DASHBOARD_HOME.
 *
 * TODO: Drop the extension branch once the extension has its own dedicated
 * sign-in page. The clamping exists only because the extension currently shares
 * this sign-in route. A corrupted callbackUrl would otherwise render the
 * dashboard home inside of the side panel.
 */
function resolveCallbackUrl(searchParams: ReadonlyURLSearchParams): string {
  const rawCallback = searchParams.get('callbackUrl');
  const isExtensionFlow = searchParams.get(EXTENSION_SOURCE_PARAM) === EXTENSION_SOURCE_VALUE || rawCallback?.startsWith(EXTENSION_PATH_PREFIX) === true;
  if (isExtensionFlow) {
    return rawCallback?.startsWith(EXTENSION_PATH_PREFIX) ? rawCallback : AUTH_PATHS.EXTENSION_HOME;
  }
  return rawCallback || AUTH_PATHS.DASHBOARD_HOME;
}